var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-typer',{attrs:{"id":"typewriter","repeat":0,"type-delay":5,"text":_vm.text,"preTypeDelay":1000},on:{"typed":function($event){return _vm.$emit('typed')},"typed-char":_vm.onTypedChar}})
}
var staticRenderFns = []

export { render, staticRenderFns }